import {ImageProvider} from '@daedalus/core/src/staticContent/types/ImageProvider'

export const imageProvider: ImageProvider = url => {
  return decodeURIComponent(url)
}
